export default __webpack_public_path__ + "static/cypress_flats_counterfeit-4b4ebb927c381eecc59ee33d82e46ebe.png";